// routes/_app.payment.subscription.result.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_app.payment.subscription.result')

export const handle = {
  name: 'payment/result',
  hideMembershipBanner: true,
  showCreditPill: true,
}

export default dynamic(getClientModule, { ssr: false })
